// components
import ticketActions from '../../constants/ticketActions';
import LOG_VERBS from '../log/logConstants';

const t = {
  [ticketActions.ON_THE_WAY]: 'On the way',
  [LOG_VERBS.ON_THE_WAY]: 'On the way',
  //
  [LOG_VERBS.DELAYED]: 'Incident report',
  [ticketActions.DELAYED]: 'Incident report',
  //
  [ticketActions.DELIVERED]: 'Finished',
  [LOG_VERBS.DELIVERED]: 'Finished',
  //
  [ticketActions.PICKUP]: 'Load validation',
  [LOG_VERBS.PICKUP]: 'Load validation',
  //
  networkFailure: 'There has been a network failure',
  disabledTooltipSendUpdate:
    'To be able to send update messages, the ticket needs to be moved to the TMS',
  logTitle: 'Message sent to customer',
  sendMessage: 'Send message',
  back: 'Back',
  send: 'Confirm',
  //
  pickupSection: 'Pickup',
  incidentSection: 'Incident data',
  dropoffSection: 'Dropoff',
  detailsSection: 'Complementary details',
  etaSection: 'Estimated time of arrival',
  loadSection: 'Load',
  vehicleSection: 'Vehicle plate',
  //
  city: 'City',
  country: 'Country',
  load: 'Load',
  plate: 'Plate',
  detailsInputText: 'Details',
  dateInputText: 'Date',
  timeInputText: 'Time',
  //
  launchOffer: 'Publish offer',
  segment: 'Segment',
  noSegments: 'No segments available',
  carrierSummary: 'This offer will be sent to:',
  selectAllCarriers: 'Select all carriers',
  carriers: 'carriers',
  noCarriers: 'No carriers available',
  disabledTooltipLaunchOffer:
    'Ticket can be offered to carriers only when state is "PENDING", "QUOTE SENT" or "QUOTE REJECTED"',
  disabledTooltipLaunchOfferNoAgent:
    'Ticket can be offered to carriers only when it has an agent assigned',
  //
  assignedCarrier: 'Assigned carrier',
  selectGroup: 'Select the group that will receive the offer:',
  finishCostNegotiationConfirmationMessage: 'Do you want to finish cost negotiation?',
  finishCostNegotiationConfirmationMessageWithBids:
    'An automatic message will be sent to all carriers that have replied to the offer.',
  finishCostNegotiationConfirmationMessageWithoutBids:
    'No reply has been received from the carriers, therefore no automatic message will be sent.',
  finishCostNegotiation: 'Finish cost negotiation',
  changeAssignment: 'Change assignment',
  finishCostNegotiationDisabledTooltip:
    'Cost negotiation can only be finished when there is a valid quote (not rejected or expired)',
  //
  closeAuctions: 'Unpublish offer',
  closeAuctionsCopy1: 'Active offers will be closed and carriers will not be able to send costs',
  closeAuctionsCopy2: 'You will be able to publish a new offer to the same or different carriers',
  closeAuctionsDisabledTooltip: 'Offers for this ticket can not be closed',
  closeAuctionBackendError: 'There was an error unpublishing the offer',
};

export default t;
